import { Component, OnInit } from '@angular/core';
import { LiquidacionService } from 'src/app/services/liquidacion/liquidacion.service';
import { guardarArchivo } from 'src/app/utils/descargar';

/**
 * CONSULTAS → CUOTAS A MEDIAS (D2-bis, CPC-88; Mario 29-oct). Las cuotas que se liquidan por cuota completa y esperan que
 * el cliente termine de pagarlas, tal como quedaron en la foto del cierre del día. Filtros: día (por omisión el último
 * cerrado) y comercio. Arriba el total por comercio, que cuadra con «espera la cuota» del cuadre. Las páginas vienen
 * del núcleo por llave (CPC-85/87): «Ver más» pide la siguiente; un filtro nuevo empieza de cero.
 */
@Component({
  selector: 'app-liquidacion-cuotas-medias',
  templateUrl: './liquidacion-cuotas-medias.component.html'
})
export class LiquidacionCuotasMediasComponent implements OnInit {
  f = { dia: '', comercio: '' };
  r: any = null;
  filas: any[] = [];
  cargando = false;
  descargando = false;
  error = '';

  constructor(private liq: LiquidacionService) { }

  ngOnInit(): void { this.buscar(); }

  private pedido = 0;

  /** Primera página (mas = false) o la siguiente (mas = true); una respuesta vieja que llega tarde se descarta. */
  buscar = async (mas = false): Promise<void> => {
    const n = ++this.pedido;
    this.cargando = true; this.error = '';
    const sig = mas && this.r?.siguiente
      ? { desde_comercio: this.r.siguiente.code, dias: this.r.siguiente.dias, cuota: this.r.siguiente.cuota } : {};
    try {
      const r = await this.liq.cuotasAMedias({ dia: this.f.dia, comercio: this.f.comercio, ...sig });
      if (n !== this.pedido) return;
      this.filas = mas ? [...this.filas, ...(r.filas || [])] : (r.filas || []);
      this.r = r;
      if (!this.f.dia && r.dia) this.f.dia = r.dia;
    } catch (e: any) { if (n === this.pedido) this.error = e?.error?.msg || 'No se pudo leer el reporte de cuotas a medias.'; }
    finally { if (n === this.pedido) this.cargando = false; }
  };

  descargar = async (): Promise<void> => {
    this.descargando = true; this.error = '';
    try {
      const blob = await this.liq.excelCuotasAMedias({ dia: this.r?.dia || this.f.dia, comercio: this.f.comercio });
      guardarArchivo(blob, `cuotas-a-medias-${String(this.r?.dia || this.f.dia).replace(/-/g, '')}${this.f.comercio ? '-' + this.f.comercio : ''}.xlsx`);
    } catch (e: any) { this.error = e?.error?.msg || 'No se pudo descargar el Excel.'; }
    finally { this.descargando = false; }
  };

  /** Bs con la tasa BCV del cierre (la misma de la foto), al centavo. */
  bs = (usd: number): number | null => (this.r?.tasa_bcv ? Math.round((Number(usd) || 0) * this.r.tasa_bcv * 100) / 100 : null);

  /** El total del comercio elegido (o de todos), de la foto del cierre. */
  get totalVisto(): number {
    const pc = this.r?.resumen?.por_comercio || [];
    return this.f.comercio ? (pc.find((c: any) => c.code === this.f.comercio)?.abonado || 0) : (this.r?.resumen?.total || 0);
  }
  get cuotasVistas(): number {
    const pc = this.r?.resumen?.por_comercio || [];
    return this.f.comercio ? (pc.find((c: any) => c.code === this.f.comercio)?.cuotas || 0) : pc.reduce((a: number, c: any) => a + (c.cuotas || 0), 0);
  }
}
